import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  key: string;
  retrieveDocumentKey(
    request: Boundaries["retrieveDocumentKey"]["request"],
  ): void;
}

function useRetrieveDocumentKey(documentId: string): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveDocumentKeyRequestPending(documentId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveDocumentKeyRequestSuccess(documentId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveDocumentKeyRequestFailure(documentId),
    ),
    key: useSelector(() => selector.retrieveDocumentKey(documentId)),
    retrieveDocumentKey: core.retrieveDocumentKey,
  };
}

export { useRetrieveDocumentKey };
